export default __webpack_public_path__ + "static/media/323-tile.ab0a20d3.svg";